export default function htmlDecode(input) {
    if (typeof input !== 'string') {
        return input;
    }
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
}
